
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gef2L", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cBjwK = parcelRequire("cBjwK");


var $3gadb = parcelRequire("3gadb");


var $iOozU = parcelRequire("iOozU");


var $gLUd5 = parcelRequire("gLUd5");


var $68uaC = parcelRequire("68uaC");


var $6PAZq = parcelRequire("6PAZq");

const $daca05cfcc3e9fff$export$a6487534b1473eb = ()=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = $daca05cfcc3e9fff$var$getBuildInfo();
        $[0] = t0;
    } else t0 = $[0];
    const { frontendVersion: frontendVersion, buildDate: buildDate } = t0;
    const hasBifrostOverride = (0, $68uaC.Cookies).get("bifrost-override");
    const tooltipMessage = `Click to exit branch deploy. Using ${hasBifrostOverride ? "Bifrost" : ""} branch deploy ${frontendVersion}.\nBuilt ${buildDate}.`;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6PAZq.ConfigurationButton), {
            "data-testid": "app-navigation-wordmark-branch",
            onClick: (0, $gLUd5.exitBranchFn)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: tooltipMessage,
            css: {
                whiteSpace: "pre-line"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iOozU))), {
            label: "Exit branch"
        })));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $daca05cfcc3e9fff$var$getBuildInfo = ()=>{
    const info = {
        frontendVersion: '',
        buildDate: ''
    };
    // Needs to be ts-ignore for now since it won't throw an error
    // until we move to project references
    // @ts-ignore tsc compile cannot find on global window object
    if (!window || !window.__buildInfo) return info;
    // Needs to be ts-ignore for now since it won't throw an error
    // until we move to project references
    // @ts-ignore tsc compile cannot find on global window object
    const buildInfo = window.__buildInfo;
    if (buildInfo.FRONTEND_VERSION) info.frontendVersion = buildInfo.FRONTEND_VERSION.replace(/^CLASSIC-/, '');
    if (buildInfo.BUILD_DATE) info.buildDate = (0, $cBjwK.default)(buildInfo.BUILD_DATE, Date.now());
    return info;
};
module.exports["BranchDeployLogo"] = $daca05cfcc3e9fff$export$a6487534b1473eb;

});

parcelRegister("6PAZq", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $c7f6301e4003b18e$var$configurationButtonStyle = null; //eslint-disable-next-line  @atlaskit/design-system/no-html-button
const $c7f6301e4003b18e$export$d135bcb304f7cb12 = (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $gMc0m.default)([
            "_11q71gly _2rko1rr0 _19it1j28 _4t3i1f4h _1bsb1f4h _syaz1tmw _1e0c1txw _4cvr1h6o _1bah1h6o _80omtlke _1q5t1r31 _nt751r31 _1ohyglyw _49pcglyw _1r9x1o36 _1hvw1o36"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button", {
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
module.exports["ConfigurationButton"] = $c7f6301e4003b18e$export$d135bcb304f7cb12;

});


//# sourceMappingURL=BranchDeployLogo.cc5d4395.js.map
